module.exports = __webpack_public_path__ + "img/safety-title.bef3c4bb.svg";